module.exports = __webpack_public_path__ + "static/scale-model-of-heritage-farmstead-museum-in-richardson-texas-29a924a30808be62c0de9e3b6c3905d1.png";